import { createFileRoute } from "@tanstack/react-router";

import { PeoplePanel } from "../../../workspaces/settings/PeoplePanel";

export const Route = createFileRoute("/_console/settings/people")({
  component: PeoplePanel,
});
